import ForgotPin from "./ForgotPinContainer";

export default {
  ForgotPin
};
